import React from "react";
import { Colors } from "../../utils/colors";
import { RadioButton } from "../radioButton/RadioButton";
import { DefaultCardNumber } from "../defaultPaymentCard/DefaultCardNumber";
import { DefaultCardExpiry } from "../defaultPaymentCard/DefaultCardExpiry";
import { PaymentCard as Card } from "../../apis/types";
import { usePaymentStore } from "../../stores/StoreContext";

type props = {
  card: Card;
};

export const PaymentCard: React.FC<props> = ({ card }) => {
  const paymentStore = usePaymentStore();
  return (
    <div
      onClick={() => {
        paymentStore.changeDefaultPaymentCard(card.id);
      }}
      style={{
        border: `2px solid ${Colors.green}`,
        width: "100%",
        display: "flex",
        padding: "8px 10px",
        borderRadius: 20,
        marginBottom: 20,
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <div>
        <DefaultCardNumber cardNumber={card.displayName} />
        <DefaultCardExpiry expiryDate={card.validUntil} />
      </div>
      <RadioButton
        selected={paymentStore.defaultPaymentCard?.id === card.id}
        onChange={() => {
          paymentStore.changeDefaultPaymentCard(card.id);
        }}
      />
    </div>
  );
};
